import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export default function TimeRestrictedModal({ open, onClose, remainingTime }) {
  const INITIAL_TIME = remainingTime; // seconds
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);

  useEffect(() => {
    if (!open) return;

    setTimeLeft(INITIAL_TIME);

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [open]);

  const handleSubmit = () => {
    alert("Submitted successfully!");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} disableEscapeKeyDown>
      <DialogTitle>Submission Locked</DialogTitle>

      <DialogContent>
        <Typography variant="h6">
          You cannot submit this exam before the time ends{" "}
        </Typography>

        <Typography
          variant="h6"
          sx={{ mt: 1, color: timeLeft === 0 ? "green" : "red" }}
        >
          Time Left: {remainingTime} sec
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
